import React from "react";
import { useQueryBuilder } from "../../Builder/hooks/useQueryBuilder";
import { CardContent } from "../../Builder/Components/UI/card";
import { Label } from "../../Builder/Components/UI/label";
import { useIncidentList } from "../../../../../../screens/User/IncidentsList/utils";
import { Select } from "../../../../../User/analytics/fall-analysis/form/sharedImports";

interface FacilityInputProps {
  className?: string;
}

export const BuilderFacilityInput: React.FC<FacilityInputProps> = ({
  className,
}) => {
  const { setFacilityId, facilityId } = useQueryBuilder();

  const { facilities } = useIncidentList();

  const handleInputChange = (vals: string[]) => {
    setFacilityId(vals);
  };

  return (
    <div className={className}>
      <CardContent>
        <div className="grid w-full items-center gap-4">
          <div className="flex flex-col space-y-1.5">
            <Label htmlFor="facilityId" className="pb-2">
              Facility
            </Label>
            <Select
              id="facilityId"
              placeholder="Select Facility"
              name="facilityId"
              onChange={(val: any) => {
                console.log({ val });
                const vals = val.map((v: any) => v.value);
                handleInputChange(vals);
              }}
              options={facilities.toSorted((a: any, b: any) =>
                a.label > b.label ? 1 : -1
              )}
              defaultValue={facilityId}
              isMulti
              components={{
                IndicatorSeparator: () => null,
              }}
            />
          </div>
        </div>
      </CardContent>
    </div>
  );
};
